import { DISMISSED_BADGE_NOTIFICATION_KEY } from 'Constants/constants'
import { NotificationBadge } from 'Core/Workbench'
import { useState, useCallback, useEffect } from 'react'

export type NotificationBadgeAccessorType = {
    items: NotificationBadge[]
    addNotificationBadge: (item: NotificationBadge) => void
    dismissNotificationBadge: (id: string) => void
}

export const useNotificationBadge = (taskId: string): NotificationBadgeAccessorType => {
    const [notifications, setNotifications] = useState<NotificationBadge[]>([])
    const [dismissed, setDismissed] = useState<Record<string, string[]>>(() => {
        const savedDismissed = localStorage.getItem(DISMISSED_BADGE_NOTIFICATION_KEY) ?? '{}'
        return JSON.parse(savedDismissed) ?? {}
    })

    useEffect(() => {
        localStorage.setItem(DISMISSED_BADGE_NOTIFICATION_KEY, JSON.stringify({ ...dismissed }))
    }, [dismissed])

    const addNotificationBadge = useCallback(
        (item: NotificationBadge) => {
            setNotifications(currentNotifications => {
                if (dismissed[taskId]?.includes(item.id)) return currentNotifications
                return [...currentNotifications, item]
            })
        },
        [dismissed, taskId]
    )

    const dismissNotificationBadge = useCallback(
        (id: string) => {
            if (notifications.find(notification => notification.id === id)) {
                setDismissed(prev => {
                    return {
                        ...prev,
                        [taskId]: prev[taskId] ? [...prev[taskId], id] : [id],
                    }
                })
                setNotifications(curr =>
                    curr.filter(notificationBadge => notificationBadge.id !== id)
                )
            }
        },
        [notifications, taskId]
    )

    return {
        items: notifications,
        addNotificationBadge,
        dismissNotificationBadge,
    }
}
